const certificateTemplateEndpoints = {
  LIST: 'certificate-template-management',
  CREATE: 'certificate-template-management/certificate-templates',
} as const;

export default certificateTemplateEndpoints;
